<template>
    <form-dialog :value="value" @input="$emit('input', $event)">
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #default="{ close }">
            <set-azure-arm-credentials-card :disabled="disabled" :loading="loading" :value="edit">
                <template #actions="{ form, isValid, clear, formId }">
                    <back-button @click="close().then(clear)"></back-button>
                    <v-spacer></v-spacer>
                    <slot name="actions" :form="form" :formId="formId" :isValid="isValid" :clear="clear" :close="close">
                    </slot>
                </template>
            </set-azure-arm-credentials-card>
        </template>
    </form-dialog>
</template>

<script>
import SetAzureArmCredentialsCard from '@/components/Settings.CloudAccounts/Azure/SetAzureARMCredentialsCard';
export default {
    props: ['value', 'loading', 'disabled', 'edit'],
    components: { SetAzureArmCredentialsCard },
    methods: {
        open() {
            this.$emit('input', true);
        },
    },
};
</script>